import { initializeApp } from 'firebase/app';
import { activate, getRemoteConfig, onConfigUpdate } from 'firebase/remote-config';

export const app = initializeApp(JSON.parse(process.env.APP_FIREBASE_CONFIG!));
export const remoteConfig = getRemoteConfig(app);

remoteConfig.defaultConfig = {
  show_buy_balance_page: false,
  schedule: JSON.stringify({
    monday: { startTime: '08:00 am', endTime: '6:00 pm' },
    tuesday: { startTime: '08:00 am', endTime: '6:00 pm' },
    wednesday: { startTime: '08:00 am', endTime: '6:00 pm' },
    thursday: { startTime: '08:00 am', endTime: '6:00 pm' },
    friday: { startTime: '08:00 am', endTime: '6:00 pm' },
    saturday: { startTime: '08:00 am', endTime: '6:00 pm' },
    sunday: { startTime: '08:00 am', endTime: '6:00 pm' }
  })
};

onConfigUpdate(remoteConfig, {
  next: () => { void activate(remoteConfig).catch(console.error); },
  error: (error) => console.error('Remote Config update failed:', error),
  complete: () => console.log('Remote Config listener stopped.')
});
